/**
 * @interface ImageRepository
 */
export class ImageRepository {
  /** @returns {Promise<string>} - URL of uploaded image */
  async uploadProfileImage(userId, file) { throw new Error('Not implemented'); }

  /** @returns {Promise<void>} */
  async deleteProfileImage(userId) { throw new Error('Not implemented'); }
}
